module.exports = __webpack_public_path__ + "static/img/098_TO8_1778_og.15a8da8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/098_TO8_1778_og.jpg
// module id = gEvY
// module chunks = 0